import React from 'react';

import { LsValueType } from '../../enums/LsValueType';
import oauthRedirect from '../../features/authentication/oauthRedirect';
import ss from '../../utils/ss';
import { Wrapper, Body } from '../elements/wrappers';
import { useLocation } from '@cthings.co/router-dom';
import { ManageTitle } from '../../features/manageTitle/ManageTitle';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccess, selectLanguageStrings } from '../../app/state/user';
import { Navigation } from '../../features/navigation/Navigation';
import { MenuItemType } from '../../features/navigation/MenuItem';
import { injectPathParams, PATHS } from '../../routes/paths';
import { View } from '../../routes';
import { selectDevices } from '../../app/state/insight';
import { useUserAccess } from '../../api/user';
import { selectManagmentSearchValue, setManagmentSearchValue } from '../../app/state/app';
import { MAPBOX_FLAG } from '../../consts';
import { useViewMatch } from '../../routes/utils';
import { startCompanyCreation } from '../../app/state/organisations';
import { ManageTableType } from '../../components/manageLayout/ManageLayout';
import { renderRoutes } from '../../utils/renderRoutes';
import withAuth from '../../features/authentication/withAuth';
import { AccessHandler } from '../../features/accessHandler/AccessHandler';
import { InvalidVATBanner } from '../../features/invalidVATBanner/InvalidVATBanner';

export const ManagementMobile = (props: any) => {
  const dispatch = useDispatch();
  useUserAccess();
  const globalAccess = useSelector(selectAccess);
  const languageStrings = useSelector(selectLanguageStrings);
  const { role_name } = globalAccess;
  const { role } = globalAccess;
  const isNotUser = role !== 0;
  const isVATInvalid = globalAccess.billing.vat_invalid;
  const location = useLocation();
  const currentRoute = location.pathname.split('/');
  const type =
    currentRoute[2] === 'organisations'
      ? ManageTableType.CLIENTS_TABLE
      : currentRoute[2] === 'devices'
      ? ManageTableType.DEVICES_TABLE
      : currentRoute[2] === 'users'
      ? ManageTableType.USERS_TABLE
      : ManageTableType.MEASUREMENT_TABLE;

  const devices = useSelector(selectDevices);

  const { zoom_level_mapbox, centre_coord } = devices;

  const searchValue = useSelector(selectManagmentSearchValue);

  const handleLogout = (e: any) => {
    e.preventDefault();
    ss.remove(LsValueType.token);
    oauthRedirect();
  };

  const setSearchValue = (value: string) => {
    dispatch(setManagmentSearchValue(value));
  };

  const handleAdd = () => {
    if (type === ManageTableType.CLIENTS_TABLE) {
      dispatch(startCompanyCreation());
    }
  };

  const menuItemArray = [
    { type: MenuItemType.DASHBOARD, route: PATHS.USER_DASHBOARD, value: languageStrings.dashboardTitle },
    {
      type: MenuItemType.INSIGHT,
      route: injectPathParams(PATHS.USER_INSIGHTS, {
        lat: centre_coord.lat || 54.5,
        lon: centre_coord.lng || 17.54,
        zoom: zoom_level_mapbox || 5,
      }),
      value: languageStrings.navigationInsight,
      hidden: !MAPBOX_FLAG,
    },
    {
      type: MenuItemType.INCIDENTS,
      route: PATHS.USER_INCIDENTS,
      value: languageStrings.navigationIncidents,
    },
    {
      type: MenuItemType.MANAGE,
      route: View.MANAGE,
      value: languageStrings.navigationManage,
      childRoutes: [
        {
          name: languageStrings.navigationClients,
          to: PATHS.MANAGE_ORGANISATIONS,
        },
        {
          name: languageStrings.navigationDevices,
          to: PATHS.MANAGE_DEVICES,
        },
        {
          name: languageStrings.navigationUsers,
          to: PATHS.MANAGE_USERS,
        },
      ],
    },
    {
      type: MenuItemType.REPORTS,
      route: PATHS.USER_REPORTS,
      value: languageStrings.navigationReports,
    },
    {
      type: MenuItemType.ANALYTICS,
      route: View.MANAGE_ANALYTICS,
      value: languageStrings.analyticsItem,
      childRoutes: [
        {
          name: languageStrings.measurementItem,
          to: PATHS.MANAGE_MEASUREMENT,
        },
      ],
    },
    {
      type: MenuItemType.BILLING,
      route: View.BILLING,
      value: languageStrings.billing,
      childRoutes: [
        // {
        //   name: languageStrings.plans,
        //   to: PATHS.BILLING_PLANS,
        // },
        {
          name: languageStrings.invoices,
          to: PATHS.BILLING_INVOICES,
        },
        {
          name: languageStrings.details,
          to: PATHS.BILLING_DETAILS,
        },
      ],
    },
    {
      type: MenuItemType.DOCUMENTS,
      route: PATHS.USER_DOCUMENTS,
      value: languageStrings.navigationDocuments,
    },

    // {
    //   type: MenuItemType.SETTINGS,
    //   route: View.USER_SETTINGS,
    //   value: languageStrings.navigationSettings || 'Settings',
    //   disabled: true,
    // },
  ];

  const menuMobileItemArray = [
    { type: MenuItemType.DASHBOARD, route: PATHS.USER_DASHBOARD, value: languageStrings.dashboardTitle },
    {
      type: MenuItemType.INSIGHT,
      route: injectPathParams(PATHS.USER_INSIGHTS, {
        lat: centre_coord.lat || 54.5,
        lon: centre_coord.lng || 17.54,
        zoom: zoom_level_mapbox || 5,
      }),
      value: languageStrings.navigationInsight,
      hidden: !MAPBOX_FLAG,
    },
    {
      type: MenuItemType.MANAGE,
      route: View.MANAGE,
      value: languageStrings.navigationManage,
      childRoutes: [
        {
          name: languageStrings.navigationClients,
          to: PATHS.MANAGE_ORGANISATIONS,
        },
        {
          name: languageStrings.navigationDevices,
          to: PATHS.MANAGE_DEVICES,
        },
        {
          name: languageStrings.navigationUsers,
          to: PATHS.MANAGE_USERS,
        },
      ],
    },
    {
      type: MenuItemType.REPORTS,
      route: PATHS.USER_REPORTS,
      value: languageStrings.navigationReports,
    },
    {
      type: MenuItemType.ANALYTICS,
      route: View.MANAGE_ANALYTICS,
      value: languageStrings.analyticsItem,
      childRoutes: [
        {
          name: languageStrings.measurementItem,
          to: PATHS.MANAGE_MEASUREMENT,
        },
      ],
    },
    {
      type: MenuItemType.BILLING,
      route: View.BILLING,
      value: languageStrings.billing,
      childRoutes: [
        // {
        //   name: languageStrings.plans,
        //   to: PATHS.BILLING_PLANS,
        // },
        {
          name: languageStrings.invoices,
          to: PATHS.BILLING_INVOICES,
        },
        {
          name: languageStrings.details,
          to: PATHS.BILLING_DETAILS,
        },
      ],
    },
  ];

  const matchPath = useViewMatch();

  const withoutPadding =
    matchPath((View as any).USER_PAIR_DEVICE_INSIGHTS) || matchPath((View as any).USER_MEASUREMENT_DEVICE_INSIGHTS);

  const withoutManageTitle = matchPath((View as any).MANAGE_ORGANISATIONS_DETAILS);

  return (
    <AccessHandler>
      <Wrapper>
        <Navigation
          menuItemArray={menuItemArray}
          menuMobileItemArray={menuMobileItemArray}
          onLogout={handleLogout}
          userStatus={role_name}
          withLanguages
        />
        {!currentRoute.includes('analytics') && !withoutManageTitle && (
          <ManageTitle
            type={type}
            handleAddOnClick={handleAdd}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            accessData={
              type === ManageTableType.CLIENTS_TABLE
                ? globalAccess.management.client.edit
                : type === ManageTableType.USERS_TABLE
                ? globalAccess.management.user.edit
                : type === ManageTableType.MEASUREMENT_TABLE
            }
          />
        )}
        <Body withoutPadding={!!withoutPadding}>{renderRoutes(props.routes, props.parentPathLength)}</Body>
        {isNotUser && isVATInvalid && <InvalidVATBanner hideButton={!!matchPath((View as any).BILLING_DETAILS)} />}
      </Wrapper>
    </AccessHandler>
  );
};

export default withAuth(ManagementMobile);
